"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Offices = exports.SecurityAccount = exports.AWSAccounts = exports.AWSRegions = void 0;
/**
 * Map each allowed regions with their shared VPC ips
 */
exports.AWSRegions = {
    "us-west-2": {
        id: 16,
        ips: "10.251.16.0/20",
        azs: ["a", "b", "c"]
    },
    "us-east-1": {
        id: 0,
        ips: "10.251.0.0/20",
        azs: ["a", "b", "c"]
    },
    "eu-west-1": {
        id: 96,
        ips: "10.251.96.0/20",
        azs: ["a", "b", "c"]
    },
    /*
    // TODO Uncomment when infrastructure is ok as TransitGateway peering is available
    "ca-central-1": {
      id: 48,
      ips: "10.251.48.0/20",
      azs: ["a", "b"],
    },
    */
    "eu-west-3": {
        id: 112,
        ips: "10.251.112.0/20",
        azs: ["a", "b", "c"]
    },
    "ap-northeast-1": {
        id: 192,
        ips: "10.251.192.0/20",
        azs: ["d", "b", "c"]
    }
};
/**
 * Static definition of our accounts
 */
exports.AWSAccounts = [
    {
        Id: "820410587685",
        Alias: "security",
        Regions: Object.keys(exports.AWSRegions),
        Contact: "security-team@nuxeo.com"
    },
    { Id: "254525589362", Alias: "hosting", Regions: [], Contact: "nco@nuxeo.com" },
    { Id: "188670881089", Alias: "nxio", Regions: [], Contact: "nco@nuxeo.com" },
    { Id: "311032021612", Alias: "presales", Regions: [], Contact: "presales@nuxeo.com" },
    { Id: "783725821734", Alias: "sandbox", Regions: ["eu-west-1", "us-east-1"] },
    { Id: "520315155131", Alias: "openshift", Regions: [], Contact: "nco@nuxeo.com" },
    { Id: "762822024843", Alias: "devtools", Regions: ["eu-west-1", "us-east-1"], Contact: "security-team@nuxeo.com" },
    { Id: "070321744989", Alias: "qa", Regions: [] },
    { Id: "531003974115", Alias: "aws", Main: true, Regions: [], Contact: "security-team@nuxeo.com" }
];
exports.AWSAccounts.slice(1).forEach(a => a.Regions.forEach(reg => {
    if (exports.AWSAccounts[0].Regions.indexOf(reg) < 0) {
        exports.AWSAccounts[0].Regions.push(reg);
    }
}));
exports.SecurityAccount = exports.AWSAccounts[0];
exports.Offices = [
    "paris.offices.nuxeo.com",
    "nyc.offices.nuxeo.com",
    "london.offices.nuxeo.com",
    "lisbon.offices.nuxeo.com",
    "oc.offices.nuxeo.com"
];
//# sourceMappingURL=aws.js.map